import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon",
  style: {"width":"1em","height":"1em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M974.77 303.262 708.922 37.415c-27.57-27.569-70.892-27.569-98.461 0s-27.57 70.893 0 98.462l13.784 13.785-319.015 210.707-9.846-9.846c-27.57-27.57-70.893-27.57-98.462 0s-27.57 70.892 0 98.462l141.785 141.784L47.262 882.215c-27.57 27.57-27.57 72.862 0 100.431 27.569 27.57 72.861 27.57 100.43 0l291.446-293.415L563.2 813.292c27.57 27.57 70.892 27.57 98.462 0s27.569-70.892 0-98.461l-9.847-9.846L860.554 384l13.784 13.785c27.57 27.569 70.893 27.569 98.462 0 27.57-23.631 27.57-66.954 1.97-94.523" }, null, -1)
  ])))
}
export default { render: render }